import { isNumber, isNaN, isString } from "underscore";

export const isDefNum = (x: any): boolean => isNumber(x) && !isNaN(x);

export const asNumber = (str: any): number => {
  if (isDefNum(str)) {
    return str;
  }

  if (isString(str) && str.trim().length > 0) {
    return Number(str);
  } else {
    return 0 / 0;
  }
};

export const round = (num: number, decimalDigits: number): number =>
  Math.round(num * Math.pow(10, decimalDigits)) / Math.pow(10, decimalDigits);
